import React from 'react';
import { Container, Box } from '@mui/material';
import {
  SectionTitle,
  SectionSubtitle,
  PurpleText,
} from '../common/components';
import { ResumeSection } from './ResumeSection';
import { experiences, education } from './data';
import resume from '../../Assets/resume.pdf';
import { ResumeSectionContainer } from './components';

export const Resume = (): React.ReactNode => {
  return (
    <ResumeSectionContainer>
      <Container maxWidth='lg'>
        <SectionTitle variant='h2'>
          My <PurpleText>Resume</PurpleText>
        </SectionTitle>

        <SectionSubtitle variant='body1'>
          My education and experience.
        </SectionSubtitle>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: 6,
          }}
        >
          <Box
            component='a'
            href={resume}
            target='_blank'
            rel='noreferrer'
            sx={{
              display: 'inline-block',
              px: 4,
              py: 2,
              backgroundColor: 'primary.main',
              color: 'white',
              textDecoration: 'none',
              borderRadius: 2,
              fontWeight: 'bold',
              transition: 'all 0.3s ease',
              '&:hover': {
                backgroundColor: 'primary.dark',
                transform: 'translateY(-2px)',
                boxShadow: '0 8px 20px rgba(199, 112, 240, 0.3)',
              },
            }}
          >
            Download Resume
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            gap: 4,
          }}
        >
          <ResumeSection
            title='Experience'
            items={experiences}
            type='experience'
          />
          <ResumeSection title='Education' items={education} type='education' />
        </Box>
      </Container>
    </ResumeSectionContainer>
  );
};
